export default __webpack_public_path__ + "static/media/anthem-landing-logo-color.c25436fc.svg";